







import Vue from "vue";
import { mapState } from "vuex";
import { Component } from "vue-property-decorator";
import { IState } from "@/store";
import { Contexts } from "@/models/contexts";

@Component({
  components: {
    "admin-navigation": () => import("./navigation.vue"),
    "admin-content": () => import("./content.vue")
  },
  computed: {
    ...mapState({
      windowWidth: (state: IState) => state.ui.window.width
    })
  }
})
export default class LoggedInAdmin extends Vue {
  // Data
  public windowWidth!: number;
  // Life-cycle methods
  private created() {
    window.addEventListener("storage", this.onLocalStorageChange);
  }
  private beforeDestroy() {
    window.removeEventListener("storage", this.onLocalStorageChange);
  }
  // Methods
  private async onLocalStorageChange({ key, newValue }) {
    const context = Contexts.ADMIN;
    // Sync new token values from localStorage
    if (key && key.startsWith(`${context}/auth/token/`))
      this.$store.commit("auth/updateTokenProperty", {
        context,
        key: this.$_.last(key.split("/")),
        value: newValue
      });
    // Open session expired modal
    if (key === `${context}/auth/token/access_token` && !newValue) {
      this.$store
        .dispatch("auth/tryReAuthentication", context)
        .catch(() => this.$store.dispatch("auth/handleReAuthFail", context));
    }
  }
}
